"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState, useEffect } from "react";
import { Tooltip } from "react-tooltip";
import { ApiWave } from "@/generated/models/ApiWave";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useDropOutcomes } from "@/hooks/drops/useDropOutcomes";
import { formatNumberWithCommas } from "@/helpers/Helpers";
interface WaveWinnersSmallOutcomeProps {
  readonly drop: ExtendedDrop;
  readonly wave: ApiWave;
}
export const WaveWinnersSmallOutcome: React.FC<WaveWinnersSmallOutcomeProps> = t0 => {
  const $ = _c(43);
  const {
    drop,
    wave
  } = t0;
  const [isTouch, setIsTouch] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsTouch("ontouchstart" in window);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] !== isOpen || $[3] !== isTouch) {
    t3 = e => {
      if (isTouch) {
        e.stopPropagation();
        setIsOpen(!isOpen);
      }
    };
    $[2] = isOpen;
    $[3] = isTouch;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleClick = t3;
  let t4;
  if ($[5] !== drop || $[6] !== wave) {
    t4 = {
      drop,
      wave
    };
    $[5] = drop;
    $[6] = wave;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const {
    outcomes: t5,
    haveOutcomes
  } = useDropOutcomes(t4);
  const {
    nicOutcomes,
    repOutcomes,
    manualOutcomes
  } = t5;
  if (!haveOutcomes) {
    return null;
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="tw-text-xs tw-font-medium tw-text-iron-400">Outcome Details</span>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== nicOutcomes) {
    t7 = nicOutcomes.map(_temp);
    $[9] = nicOutcomes;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== repOutcomes) {
    t8 = repOutcomes.map(_temp2);
    $[11] = repOutcomes;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== manualOutcomes) {
    t9 = manualOutcomes.map(_temp3);
    $[13] = manualOutcomes;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t7 || $[16] !== t8 || $[17] !== t9) {
    t10 = <div className="tw-p-3.5 tw-space-y-3 lg:tw-min-w-[220px] tw-backdrop-blur-xl tw-bg-iron-900/95 tw-border tw-border-iron-800/60 tw-rounded-xl tw-shadow-[0_8px_32px_rgba(0,0,0,0.35)]"><div className="tw-space-y-2.5">{t6}<div className="tw-space-y-2">{t7}{t8}{t9}</div></div></div>;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  const tooltipContent = t10;
  let t11;
  if ($[19] !== handleClick) {
    t11 = e_0 => {
      e_0.stopPropagation();
      handleClick(e_0);
    };
    $[19] = handleClick;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  const t12 = `outcome-small-${drop.id}`;
  let t13;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <span className="tw-text-xs tw-font-normal tw-text-iron-200">Outcome:</span>;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== nicOutcomes.length) {
    t14 = !!nicOutcomes.length && <svg className="tw-size-4 tw-text-[#A4C2DB] tw-flex-shrink-0" viewBox="0 0 24 24" aria-hidden="true" fill="none"><path d="M9 6.75H15M9 12H15M9 17.25H12M3.75 19.5H20.25C21.0784 19.5 21.75 18.8284 21.75 18V6C21.75 5.17157 21.0784 4.5 20.25 4.5H3.75C2.92157 4.5 2.25 5.17157 2.25 6V18C2.25 18.8284 2.92157 19.5 3.75 19.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[22] = nicOutcomes.length;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== repOutcomes.length) {
    t15 = !!repOutcomes.length && <svg className="tw-size-4 tw-text-[#C3B5D9] tw-flex-shrink-0" viewBox="0 0 24 24" aria-hidden="true" fill="none"><path d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z" stroke="currentColor" strokeWidth="1.5" /></svg>;
    $[24] = repOutcomes.length;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== manualOutcomes.length) {
    t16 = !!manualOutcomes.length && <svg className="tw-size-4 tw-text-[#D4C5AA] tw-flex-shrink-0" viewBox="0 0 24 24" aria-hidden="true" fill="none"><path d="M12 18v-3m0-3v.01M12.75 3.25h-1.5L8.5 7H4.75l.5 3.5L2 13l3.25 2.5-.5 3.5h3.75l2.75 3.75h1.5L15.5 19h3.75l-.5-3.5L22 13l-3.25-2.5.5-3.5H15.5l-2.75-3.75z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[26] = manualOutcomes.length;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== t14 || $[29] !== t15 || $[30] !== t16) {
    t17 = <div className="tw-flex tw-items-center tw-gap-2">{t14}{t15}{t16}</div>;
    $[28] = t14;
    $[29] = t15;
    $[30] = t16;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== t11 || $[33] !== t12 || $[34] !== t17) {
    t18 = <button onClick={t11} className="tw-border-0 tw-rounded-lg tw-flex tw-items-center tw-gap-2 tw-min-w-6 tw-py-1.5 tw-px-2 tw-bg-iron-800 tw-ring-1 tw-ring-iron-700" data-tooltip-id={t12}>{t13}{t17}</button>;
    $[32] = t11;
    $[33] = t12;
    $[34] = t17;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  const t19 = `outcome-small-${drop.id}`;
  let t20;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = {
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    };
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== t19 || $[38] !== tooltipContent) {
    t21 = <Tooltip id={t19} place="top" delayShow={200} style={t20}>{tooltipContent}</Tooltip>;
    $[37] = t19;
    $[38] = tooltipContent;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] !== t18 || $[41] !== t21) {
    t22 = <>{t18}{t21}</>;
    $[40] = t18;
    $[41] = t21;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  return t22;
};
function _temp(nicOutcome) {
  return <div key={`NIC-${nicOutcome.value}`} className="tw-flex tw-items-center tw-justify-between tw-p-2 tw-rounded-lg tw-bg-iron-800/40"><div className="tw-flex tw-items-center tw-gap-2"><svg className="tw-size-4 tw-text-[#A4C2DB] tw-flex-shrink-0" viewBox="0 0 24 24" aria-hidden="true" fill="none"><path d="M9 6.75H15M9 12H15M9 17.25H12M3.75 19.5H20.25C21.0784 19.5 21.75 18.8284 21.75 18V6C21.75 5.17157 21.0784 4.5 20.25 4.5H3.75C2.92157 4.5 2.25 5.17157 2.25 6V18C2.25 18.8284 2.92157 19.5 3.75 19.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg><span className="tw-text-sm tw-font-medium tw-text-iron-200">NIC</span></div><span className="tw-text-sm tw-font-semibold tw-text-[#A4C2DB]">{formatNumberWithCommas(nicOutcome.value)}</span></div>;
}
function _temp2(repOutcome) {
  return <div key={`REP-${repOutcome.category}-${repOutcome.value}`} className="tw-p-2 tw-flex tw-flex-col tw-gap-y-1 tw-rounded-lg tw-bg-iron-800/40"><div className="tw-flex tw-items-center tw-justify-between"><div className="tw-flex tw-items-center tw-gap-2"><svg className="tw-size-4 tw-text-[#C3B5D9] tw-flex-shrink-0" viewBox="0 0 24 24" aria-hidden="true" fill="none"><path d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z" stroke="currentColor" strokeWidth="1.5" /></svg><span className="tw-text-sm tw-font-medium tw-text-iron-200">Rep</span></div><span className="tw-text-sm tw-font-semibold tw-text-[#C3B5D9]">{formatNumberWithCommas(repOutcome.value)}</span></div><span className="tw-text-sm tw-font-semibold tw-text-[#C3B5D9]">{repOutcome.category}</span></div>;
}
function _temp3(outcome) {
  return <div key={`MANUAL-${outcome.description}`} className="tw-flex tw-items-center tw-justify-between tw-p-2 tw-rounded-lg tw-bg-iron-800/40"><div className="tw-flex tw-items-center tw-gap-2"><svg className="tw-size-4 tw-text-[#D4C5AA] tw-flex-shrink-0" viewBox="0 0 24 24" aria-hidden="true" fill="none"><path d="M12 18v-3m0-3v.01M12.75 3.25h-1.5L8.5 7H4.75l.5 3.5L2 13l3.25 2.5-.5 3.5h3.75l2.75 3.75h1.5L15.5 19h3.75l-.5-3.5L22 13l-3.25-2.5.5-3.5H15.5l-2.75-3.75z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg><span className="tw-text-sm tw-font-medium tw-text-iron-200">{outcome.description}</span></div></div>;
}